module.exports = __webpack_public_path__ + "media/icons/paliwa-menu-15c6ada1.png";